
// oss-文件夹管理 接口
import request from '@/utils/request.js'

/**
* 新建目录
* @param params
* @returns {AxiosPromise}
*/
export function addFolder(params) {
	return request({
		url: '/studyService/api/ossFolder/addFolder',
		method: 'post',
		data: params
	})
}

/**
* 获取全部目录tree
* @param params
* @returns {AxiosPromise}
*/
export function getTreeAll(params) {
	return request({
		url: '/studyService/api/ossFolder/getTreeAll',
		method: 'post',
		data: params
	})
}

/**
* 删除目录
* @param params
* @returns {AxiosPromise}
*/
export function removeFolder(params) {
	return request({
		url: '/studyService/api/ossFolder/removeFolder',
		method: 'post',
		data: params
	})
}
// 方法列表
// addFolder，getTreeAll，removeFolder